import React, { useCallback, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { SCROLL_INDICATOR_INSETS, rem } from 'design-system/values';
import ContactSupportTextButton from 'design-system/ContactSupportTextButton';
import { AppView, ButtonGroup, CardView, Indicator, withAnimatedNavigationHeader } from 'design-system';
import Links from 'utils/links';
import { useUserAddress } from 'hooks';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import FormattedAddress from 'features/invest/components/FormattedAddress';
import { useCommonInvestStyles } from './styles';
import { useAmplitudeOnMountEvent } from '../utils/analytics';
const KYCAddressDisplayScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation, route: { params } }) => {
    const commonStyles = useCommonInvestStyles();
    const colors = useColors();
    const { primaryAddress } = useUserAddress();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const flow = params?.flow;
    useAmplitudeOnMountEvent(flow, 'User Address Confirmation Screen');
    const onDone = useCallback(async () => {
        navigation.navigateDeprecated('InvestChooseProofOfAddress', { flow });
    }, [flow]);
    const openRequirements = useCallback(() => {
        Links.openKycProcessLink();
    }, []);
    const paddingBottom = useMarginBottom('paddingBottom', rem(20 + 56 + 56 + 16), commonStyles.contentContainer); // 56 is Button’s height, 20 is margin to the top of Button, 16 is the space between buttons
    return (<AppView withFrame={false}>
        {primaryAddress ? (<>
            <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={paddingBottom}>
              <ScreenInfoHeader smallSubTitle title="Verify your address" subTitle="You will have to upload a document to verify this address"/>
              <CardView withPadding noMarginTop>
                <FormattedAddress {...primaryAddress} uk/>
              </CardView>
              <View style={styles.horizontalPadding}>
                <Text TextThin-14 Secondary>
                  If the address provided does not match your legal address, your application will be rejected.{' '}
                  <Text Text-14 Primary onPress={openRequirements} suppressHighlighting>
                    Learn more
                  </Text>
                </Text>
              </View>
            </Animated.ScrollView>
            <ButtonGroup type="floating">
              <ContactSupportTextButton TextThin-14 Secondary title="Address is incorrect?"/>
              <Button brand title="Continue" onPress={onDone} style={styles.continueBtn}/>
            </ButtonGroup>
          </>) : (<View style={styles.indicatorContainer}>
            <Indicator dark/>
          </View>)}
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    citizenshipInfo: {
        maxWidth: '60%',
        textAlign: 'right',
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
    horizontalPadding: {
        paddingHorizontal: rem(16),
    },
    indicatorContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    continueBtn: {
        marginTop: rem(8),
    },
});
export default KYCAddressDisplayScreen;
